// ── Iyanna Chess — Accounts ─────────────────────────────────────────────
// Players sign up with a nickname + password, then log in with the same
// pair on any device.
//
// How the secret is kept safe:
//  • The password NEVER leaves the device in plain form. We derive a key
//    with PBKDF2-SHA256 (150k iterations) over a random per-account salt.
//  • The derived hash lives in `chessAuth/{nameLower}`, a collection whose
//    security rules make it UNREADABLE to everyone. Login works without
//    reading it: the client attempts a write that the rules only allow
//    when the submitted hash equals the stored one. Wrong password =
//    permission denied.
//  • `chessAuth/{nameLower}` doubles as the uniqueness lock: a create only
//    succeeds when the document does not exist yet, so two people can
//    never hold the same nickname.

const ITERATIONS = 150000;

function toHex(buffer) {
  return Array.from(new Uint8Array(buffer))
    .map(b => b.toString(16).padStart(2, '0'))
    .join('');
}

export function makeSalt() {
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  return toHex(bytes.buffer);
}

/** Derive the login hash from a password + the account's salt. */
export async function hashPassword(password, salt) {
  const enc = new TextEncoder();
  const keyMaterial = await crypto.subtle.importKey(
    'raw', enc.encode(password), { name: 'PBKDF2' }, false, ['deriveBits']
  );
  const bits = await crypto.subtle.deriveBits(
    { name: 'PBKDF2', salt: enc.encode(salt), iterations: ITERATIONS, hash: 'SHA-256' },
    keyMaterial,
    256
  );
  return toHex(bits);
}

/** True when the browser can do the crypto we need (https or localhost). */
export function cryptoAvailable() {
  return typeof crypto !== 'undefined' && !!crypto.subtle;
}

export function validatePassword(pw) {
  if (!pw || pw.length < 6) return 'Password iwe na herufi 6 au zaidi.';
  return null;
}

export function validateName(name) {
  const n = (name || '').trim();
  if (n.length < 3) return 'Jina liwe na herufi 3 au zaidi.';
  if (n.length > 20) return 'Jina lisizidi herufi 20.';
  if (!/^[\w\s.\-']+$/.test(n)) return 'Tumia herufi, namba, nafasi, nukta au dashi tu.';
  return null;
}
